import actionTypes from "../actionTypes";
import initialState from "./initialState";

export default function (state = initialState.venue, action) {
  switch (action.type) {
    case actionTypes.LOAD_ITEM_FEEDBACKS_RATING:
      return {
        ...state,
        menuRating: action.rating,
      };
    case actionTypes.LOAD_VENUE_MENU:
      return {
        ...state,
        menu: action.menu,
        menuById: action.menuById,
        positions: action.positions,
      };
    case actionTypes.LOAD_REVIEWS:
      return {
        ...state,
        reviews: action.reviews,
        garcons: action.garcons,
      };
    case actionTypes.AUTH_SUCCESS:
      return {
        ...state,
        name: action.name,
        registerStatus: action.registerStatus,
        registerCompletedSteps: action.registerCompletedSteps,
      };
    case actionTypes.LOAD_VENUE_INFO:
      return {
        ...state,
        admin: action.admin,
        schedule: action.schedule,
        address: action.address,
        paymentSettings: action.paymentSettings || {},
        venueTags: action.venueTags,
        banner: action.banner,
        icon: action.icon,
        gallery: action.gallery || [],
        commission: action.commission || {},
      };
    case actionTypes.SET_NEW_ADMIN:
      return {
        ...state,
        admin: action.admin,
      };
    case actionTypes.LOAD_SUPPORT:
      return {
        ...state,
        supportAgents: action.supportAgents,
      };
    case actionTypes.LOAD_MAILINGS:
      return {
        ...state,
        mailings: action.mailings,
      };
    case actionTypes.UPDATE_SCHEDULE:
      return {
        ...state,
        schedule: action.schedule,
      };
    case actionTypes.LOAD_STARS_ITEMS:
      return {
        ...state,
        starsActive: action.starsActive,
      };
    case actionTypes.UPDATE_PAYMENT_SETTINGS:
      return {
        ...state,
        paymentSettings: action.paymentSettings,
      };
    case actionTypes.UPDATE_REGISTER_STEPS:
      return { ...state, registerCompletedSteps: action.registerCompletedSteps };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/venue.js